import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DatePickerCreator = ({ dateFormat, startDate, handleDateChange }: any) => (
  <DatePicker dateFormat={dateFormat} selected={startDate} onChange={handleDateChange} autoComplete="disable_autocomplete" />
);
export default DatePickerCreator;
